import { createFileRoute, redirect } from "@tanstack/react-router";

const COMPUTE_LANDING_HOST = "compute.genrl.co";

function rootDestination(): "/alliancedao" | "/request-access" {
  if (
    typeof window !== "undefined" &&
    window.location.hostname.toLowerCase() === COMPUTE_LANDING_HOST
  ) {
    return "/alliancedao";
  }
  return "/request-access";
}

export const Route = createFileRoute("/")({
  head: () => ({ meta: [{ title: "GENRL Wallet" }] }),
  beforeLoad: () => {
    throw redirect({ to: rootDestination(), replace: true });
  },
  component: () => null,
});
